/* eslint-disable @next/next/no-img-element */

'use client'
import { useEffect } from 'react'
import { useI18n } from '@spot-fe/base-ui';
import Monitor from '@fe/monitor';
import styles from './index.module.scss'

export default function Errors({ platform }) {
  const { t } = useI18n();
  const monitor = new Monitor()
  useEffect(() => {
    monitor.log({
      os: platform || '',
      t: 'isRenderAppTips'
    })
  }, [])
  const str = platform === 'ios' ? t('unsupportedIosVersionMsg') : t('unsupportedAndroidVersionMsg')
  return (
    <div className={styles.appInfoWarp}>
      <img src='./imgs/rocket.png' alt="" />
      <p dangerouslySetInnerHTML={{
        __html: str
      }} />
    </div>
  )
}

